
import ClickOutside from "vue-click-outside";

export default {
  directives: { ClickOutside },

  props: {
    defaultValue: { type: String, required: false, default: "" },
    listItems: { type: Array, required: true },
  },

  data: () => ({ showContent: false, currentValue: null }),

  computed: {
    selectedValue() {
      return this.currentValue || this.defaultValue;
    },
  },

  methods: {
    handleSelect(id, label) {
      // Only emit event when value changes
      if (label !== this.selectedValue) {
        this.$emit("item-select", { id });
      }

      this.showContent = false;
      this.currentValue = label;
    },
    handleOuterClick() {
      this.showContent = false;
    },
  },
};
